import { StrengthBar } from '@dealstack/frontend/shared/components/StrengthBar/StrengthBar';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { Text } from '@mantine/core';
import { Dispatch, SetStateAction } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { TextInput } from 'react-hook-form-mantine';

interface Props {
	form: UseFormReturn<FieldValues, unknown>;
	showPassword: boolean;
	setShowPassword: Dispatch<SetStateAction<boolean>>;
	loading?: boolean;
	isPasswordValid: boolean;
	strengthScore: number;
	name: string;
	placeholder: string;
	label: string;
	hint: string;
}

export const NewPasswordInput = (props: Props) => {
	return (
		<div>
			<TextInput
				name={props.name}
				control={props.form.control}
				size="md"
				placeholder={props.placeholder}
				label={props.label}
				type={props.showPassword ? 'text' : 'password'}
				rightSection={
					<Icon
						variant={props.showPassword ? 'unview-v3' : 'view-v3'}
						onClick={() => {
							props.setShowPassword(!props.showPassword);
						}}
						size="xl"
					/>
				}
				disabled={props.loading}
				data-testid={TEST_ELEMENT_IDS.NEW_PASSWORD_INPUT}
			/>
			{!props.isPasswordValid && (
				<Text
					size="B6Medium"
					c="dark.8"
					className="mt-1"
					data-testid={TEST_ELEMENT_IDS.NEW_PASSWORD_HINT}
				>
					{props.hint}
				</Text>
			)}

			<div className="mt-4">
				<StrengthBar strengthScore={props.strengthScore} />
			</div>
		</div>
	);
};
